<script lang="ts">
  import Login from './Login.svelte';
</script>

<div class="max-w-3xl mx-auto">

  <!-- Hero -->
  <section class="text-center pt-12 sm:pt-20 pb-12">
    <div class="mb-4 sm:mb-6">
      <svg class="w-12 h-12 sm:w-16 sm:h-16 mx-auto text-[#58a6ff]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" />
        <polyline points="13 2 13 9 20 9" />
        <line x1="12" y1="18" x2="12" y2="12" />
        <line x1="9" y1="15" x2="15" y2="15" />
      </svg>
    </div>
    <h1 class="text-2xl sm:text-4xl font-bold text-[#e6edf3] mb-2 sm:mb-3 tracking-tight">blossom.psbt.me</h1>
    <p class="text-base sm:text-lg text-[#8b949e] mb-6 sm:mb-8 max-w-lg mx-auto leading-relaxed px-4">
      Cashu-powered file hosting on the Nostr ecosystem
    </p>
    <div class="flex justify-center px-4">
      <Login />
    </div>
    <p class="text-sm text-[#484f58] mt-3">Login with Nostr to start uploading</p>
  </section>

  <!-- Divider -->
  <div class="border-t border-[#21262d] mx-8"></div>

  <!-- Features -->
  <section class="py-16 px-4">
    <h2 class="text-xl font-semibold text-[#e6edf3] text-center mb-8">Features</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

      <!-- Free Tier -->
      <div class="bg-[#161b22] border border-[#21262d] rounded-lg p-6 hover:border-[#484f58] transition-colors duration-200">
        <div class="mb-4">
          <svg class="w-6 h-6 text-[#3fb950]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M16 8l-4 4-4-4" />
            <path d="M12 12v6" />
          </svg>
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Free Tier</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          1-month hosting for files under 1 MB. No payment needed to get started.
        </p>
      </div>

      <!-- Cashu Payments -->
      <div class="bg-[#161b22] border border-[#21262d] rounded-lg p-6 hover:border-[#484f58] transition-colors duration-200">
        <div class="mb-4">
          <svg class="w-6 h-6 text-[#d29922]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
          </svg>
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Cashu Payments</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          Pay per MB per day with Cashu ecash tokens. No Lightning wallet required.
        </p>
      </div>

      <!-- Nostr Auth -->
      <div class="bg-[#161b22] border border-[#21262d] rounded-lg p-6 hover:border-[#484f58] transition-colors duration-200">
        <div class="mb-4">
          <svg class="w-6 h-6 text-[#58a6ff]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
          </svg>
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Nostr Auth</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          Login with your Nostr identity. Full NIP-07 extension support.
        </p>
      </div>

      <!-- Blossom Protocol -->
      <div class="bg-[#161b22] border border-[#21262d] rounded-lg p-6 hover:border-[#484f58] transition-colors duration-200">
        <div class="mb-4">
          <svg class="w-6 h-6 text-[#bc8cff]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="16 18 22 12 16 6" />
            <polyline points="8 6 2 12 8 18" />
          </svg>
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Blossom Protocol</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          Compatible with Blossom client libraries. Use any SDK you prefer.
        </p>
      </div>

    </div>
  </section>

  <!-- Divider -->
  <div class="border-t border-[#21262d] mx-8"></div>

  <!-- How It Works -->
  <section class="py-16 px-4">
    <h2 class="text-xl font-semibold text-[#e6edf3] text-center mb-8">How It Works</h2>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6">
      <div class="text-center">
        <div class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#58a6ff1a] text-[#58a6ff] text-sm font-bold mb-4">
          1
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Login</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          Authenticate with your Nostr browser extension (NIP-07).
        </p>
      </div>
      <div class="text-center">
        <div class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#58a6ff1a] text-[#58a6ff] text-sm font-bold mb-4">
          2
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Upload</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          Drag and drop your file or select one. Get an instant shareable link.
        </p>
      </div>
      <div class="text-center">
        <div class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#58a6ff1a] text-[#58a6ff] text-sm font-bold mb-4">
          3
        </div>
        <h3 class="text-sm font-semibold text-[#e6edf3] mb-2">Share</h3>
        <p class="text-sm text-[#8b949e] leading-relaxed">
          Copy the link and share it. That is it. No accounts, no friction.
        </p>
      </div>
    </div>
  </section>

  <!-- Divider -->
  <div class="border-t border-[#21262d] mx-8"></div>

  <!-- Pricing -->
  <section class="py-16 px-4">
    <h2 class="text-xl font-semibold text-[#e6edf3] text-center mb-8">Pricing</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">

      <div class="bg-[#161b22] border border-[#21262d] rounded-lg p-6">
        <h3 class="text-sm font-semibold text-[#8b949e] uppercase tracking-wider mb-3">Free</h3>
        <div class="mb-4">
          <span class="text-3xl font-bold text-[#e6edf3]">0</span>
          <span class="text-sm text-[#8b949e] ml-1">sats</span>
        </div>
        <ul class="space-y-2 text-sm text-[#8b949e]">
          <li class="flex items-center gap-2">
            <svg class="w-4 h-4 text-[#3fb950] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Files up to 1 MB
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-4 h-4 text-[#3fb950] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            1-month hosting
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-4 h-4 text-[#3fb950] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            No payment needed
          </li>
        </ul>
      </div>

      <div class="bg-[#161b22] border border-[#58a6ff33] rounded-lg p-6 relative">
        <div class="absolute -top-2.5 left-4 px-2 py-0.5 bg-[#58a6ff1a] border border-[#58a6ff33] rounded text-[10px] font-semibold text-[#58a6ff] uppercase tracking-wider">
          Paid
        </div>
        <h3 class="text-sm font-semibold text-[#8b949e] uppercase tracking-wider mb-3 mt-1">Extended</h3>
        <div class="mb-4">
          <span class="text-3xl font-bold text-[#e6edf3]">1</span>
          <span class="text-sm text-[#8b949e] ml-1">sat / MB / month</span>
        </div>
        <ul class="space-y-2 text-sm text-[#8b949e]">
          <li class="flex items-center gap-2">
            <svg class="w-4 h-4 text-[#3fb950] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Files up to 100 MB
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-4 h-4 text-[#3fb950] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Up to 7-day hosting per payment cycle
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-4 h-4 text-[#3fb950] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Cashu ecash payments
          </li>
        </ul>
      </div>

    </div>
  </section>

  <!-- Divider -->
  <div class="border-t border-[#21262d] mx-8"></div>

  <!-- Client Libraries -->
  <section class="py-16 px-4">
    <h2 class="text-xl font-semibold text-[#e6edf3] text-center mb-8">Client Libraries</h2>
    <div class="space-y-3 max-w-lg mx-auto">

      <div class="bg-[#161b22] border border-[#21262d] rounded-lg px-5 py-3 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <span class="text-xs font-semibold text-[#d29922] uppercase tracking-wider w-20">JavaScript</span>
          <code class="text-sm text-[#e6edf3] font-mono">npm install blossom-client-sdk</code>
        </div>
      </div>

      <div class="bg-[#161b22] border border-[#21262d] rounded-lg px-5 py-3 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <span class="text-xs font-semibold text-[#3fb950] uppercase tracking-wider w-20">Python</span>
          <code class="text-sm text-[#e6edf3] font-mono">pip install python-blossom</code>
        </div>
      </div>

      <div class="bg-[#161b22] border border-[#21262d] rounded-lg px-5 py-3 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <span class="text-xs font-semibold text-[#f85149] uppercase tracking-wider w-20">Rust</span>
          <code class="text-sm text-[#e6edf3] font-mono">cargo install blossom-cli</code>
        </div>
      </div>

    </div>
    <div class="text-center mt-6">
      <a
        href="https://github.com/hzrd149/blossom"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 text-sm text-[#58a6ff] hover:underline"
      >
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
        View the Blossom specification
      </a>
    </div>
  </section>

  <!-- Disclaimer -->
  <section class="px-4 pb-8">
    <div class="max-w-2xl mx-auto bg-[#161b22] border border-[#21262d] rounded-lg p-4">
      <div class="flex items-start gap-2">
        <svg class="w-4 h-4 text-[#d29922] mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.008v.008H12v-.008z" />
        </svg>
        <div>
          <p class="text-xs text-[#8b949e] font-medium mb-1">Experimental service</p>
          <p class="text-xs text-[#484f58] leading-relaxed">
            This is an experimental project. It may be discontinued at any time without notice.
            Do not use for long-term or permanent file storage. Always keep local copies of your data.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="border-t border-[#21262d] py-8 mt-8 text-center text-xs text-[#484f58] space-y-2">
    <p>
      Open protocol:
      <a href="https://github.com/hzrd149/blossom" target="_blank" rel="noopener noreferrer" class="text-[#8b949e] hover:text-[#58a6ff] transition-colors duration-150">Blossom</a>
    </p>
  </footer>

</div>
